import PropTypes from 'prop-types'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

import { useProductTourContext, useUserContext } from '../../context'
import { usePaymentContext } from '../../context/payment-context'
import { usePersist } from '../../hooks/use-persist'
import Announcement from '../announcement'
import InnovationHelpersModal from './innovation-helpers-modal'
import InviteYourselfModal from './invite-yourself-modal'
import Tutorials from './tutorials'

// bannerOnly: nur Trial-Banner + Demo-Modal, ohne Tutorials/Invite-Modal.
// Wird im Discover-Screen genutzt, wo die Tutorials nicht laufen sollen.
const Trial = ({ bannerOnly = false }) => {
  const { t } = useTranslation()
  const { expires_at, is_trial } = usePaymentContext()
  const { isAdmin } = useUserContext()

  const navigate = useNavigate()

  const [innovationHelpersOpen, setInnovationHelpersOpen] = useState(false)

  const [displayIntroduction, setDisplayIntroduction] = usePersist({
    key: 'TRIAL:DISPLAY_INTRODUCTION',
    initialState: true
  })

  const [displayCareersTutorial, setDisplayCareersTutorial] = usePersist({
    key: 'TRIAL:DISPLAY_CAREERS_TUTORIAL',
    initialState: false
  })

  const [displayTalentsTutorial, setDisplayTalentsTutorial] = usePersist({
    key: 'TRIAL:DISPLAY_TALENTS_TUTORIAL',
    initialState: false
  })

  const {
    productTourState: { tourActive }
  } = useProductTourContext()

  if (!is_trial || tourActive) return null

  const date1 = new Date(expires_at)
  const date2 = new Date()
  const difference = date1.getTime() - date2.getTime()
  const trial_days = Math.ceil(difference / (1000 * 3600 * 24))

  if (isAdmin) {
    return (
      <Announcement
        type='INFO'
        text={t('trial.innovation_helpers.banner', { days: trial_days })}
      />
    )
  }

  return (
    <>
      <Announcement
        text={t('trial.innovation_helpers.banner', { days: trial_days })}
        type='INFO'
        onClick={() => setInnovationHelpersOpen(true)}
      />
      <InnovationHelpersModal
        open={innovationHelpersOpen}
        setOpen={setInnovationHelpersOpen}
        trialDays={trial_days}
        source={bannerOnly ? 'trial_banner_discover' : 'trial_banner'}
      />
      {bannerOnly ? null : (
        <>
          <Tutorials
            displayCareersTutorial={displayCareersTutorial}
            onCloseCareersTutorial={() => setDisplayCareersTutorial(false)}
            displayTalentsTutorial={displayTalentsTutorial}
            onCloseTalentsTutorial={() => {
              setDisplayTalentsTutorial(false)
              setTimeout(() => navigate('/talents'), 1000 * 0.4)
            }}
          />
          <InviteYourselfModal />
        </>
      )}
      {/* <Introduction
        open={displayIntroduction}
        next={() => {
          setDisplayIntroduction(false)
          setTimeout(() => {
            setDisplayCareersTutorial(true)
            setDisplayTalentsTutorial(true)
          }, 1000 * 0.4)
        }}
        trial_days={trial_days}
      /> */}
    </>
  )
}

Trial.propTypes = {
  bannerOnly: PropTypes.bool
}

Trial.defaultProps = {
  bannerOnly: false
}

export default Trial
